<div
	class="legacy-wrapper show-progress"
	[class.logo-loaded]="logoLoaded$ | async"
	[class.loader-visible]="loaderVisible$ | async"
	[class.app-initialized]="animationFinished$ | async"
>
	<ng-container *ngIf="useLottieInitAnimation; else defaultInitLogo">
		<div class="loader-wrapper w-content h-37.5 max-w-full max-h-full">
			<lottie-animation
				[path]="initLottiePath"
				[loop]="false"
				[autoplay]="false"
				(finished)="logoLoaded()"
			></lottie-animation>
		</div>
	</ng-container>

	<ng-template #defaultInitLogo>
		<div class="loader-wrapper w-35.5 max-w-4/5">
			<img
				class="left-as-is w-[205px] h-5"
				src="/assets/images/logo/logo-white-with-text.png"
				alt="myReach"
				width="205"
				height="40"
				(load)="logoLoaded()"
			/>

			<div
				class="px-3 bottom-0 left-0 w-full flex absolute items-center justify-center box-border [transform:translatey(100%)]"
			>
				<div class="loader-indicator"></div>
			</div>
		</div>
	</ng-template>

	<div class="transition-wrapper"></div>
</div>
